import { ITopicItem } from "../../models/topics/TopicItem";
import { IImageLink } from "../../models/digitalMedia/ImageLink";
import { ITopicItemViewModel } from ".";


export class TopicItemViewModel implements ITopicItemViewModel {

  /**
   * @method Constructor method
   * @param {ITopicItem} topicItem A reference to the underlying TopicItem object
   * @param {IImageLink | undefined} profileImage If defined, a reference to an associated IImageLink (the TopicItem Profile image)
   */
  constructor(
    topicItem: ITopicItem,
    profileImage?: IImageLink
  ) {

    // assign properties from ctor parameters
    this._topicItem = topicItem;
    this._profileImage = profileImage;
  }


  /*-----------------------------------------------*/
  /**
   * @property {ITopicItem} _topicItem A reference to the underlying TopicItem object
   */
  private _topicItem: ITopicItem;

  /**
   * @method topicItem Getter method for _topicItem
   */
  get topicItem(): ITopicItem {
    return this._topicItem;
  }

  /**
   * @method topicItem Setter method for _topicItem
   * @param {ITopicItem} value The input value for setting _topicItem
   */
  set topicItem(value: ITopicItem) {
    this._topicItem = value;
  }
  /*-----------------------------------------------*/

  /*-----------------------------------------------*/
  /**
   * @property {IImageLink | undefined} _profileImage If defined, a reference to an associated IImageLink (the TopicItem Profile image)
   */
  private _profileImage: IImageLink | undefined = undefined;

  /**
   * @method profileImage Getter method for _profileImage
   */
  get profileImage(): IImageLink | undefined {
    return this._profileImage;
  }

  /**
   * @method profileImage Setter method for _profileImage
   * @param {IImageLink | undefined} value The input value for setting _profileImage
   */
  set profileImage(value: IImageLink | undefined) {
    this._profileImage = value;
  }
  /*-----------------------------------------------*/

}